// import React, { useState } from "react";
// import "./Contact.css";
// import "./Footer.css";

// const Contact = () => {
//     const [formData, setFormData] = useState({
//         fullName: "",
//         email: "",
//         phone: "",
//         persons: "",
//         serviceType: "Day Rent",
//         tourLocation: "",
//     });

//     const [status, setStatus] = useState("");
//     const [isLoading, setIsLoading] = useState(false);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // Validate phone number format (Only on submit)
//         const phonePattern = /^[6789]\d{9}$/; // Indian Mobile Number Format
//         if (!phonePattern.test(formData.phone)) {
//             setStatus("Please enter a valid 10-digit Indian mobile number.");
//             return;
//         }

//         setIsLoading(true);
//         setStatus("");

//         try {
//             const response = await fetch("https://smtp-server-zscs.onrender.com/send-email", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify(formData),
//             });

//             const data = await response.json();
//             console.log("Server Response:", data);

//             if (response.ok) {
//                 setStatus("Your booking is confirmed. Our team will contact you soon!");
//                 setFormData({
//                     fullName: "",
//                     email: "",
//                     phone: "",
//                     persons: "",
//                     serviceType: "Day Rent",
//                     tourLocation: "",
//                 });
//             } else {
//                 setStatus(data.message || "Error sending message. Please try again.");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//             setStatus("Network error. Please try again.");
//         }

//         setIsLoading(false);
//         setTimeout(() => setStatus(""), 5000);
//     };

//     return (
//         <div className="container">
//             <div className="row d-flex align-items-center">
//                 <div className="col-md-6">
//                     <form className="contact-form" onSubmit={handleSubmit}>
//                         <h1 className="contact-title">Book Online</h1>

//                         <label>Full Name *</label>
//                         <input
//                             type="text"
//                             name="fullName"
//                             placeholder="E.g: Praveen"
//                             required
//                             value={formData.fullName}
//                             onChange={handleChange}
//                         />

//                         <label>Email Address *</label>
//                         <input
//                             type="email"
//                             name="email"
//                             placeholder="mail@example.com"
//                             required
//                             value={formData.email}
//                             onChange={handleChange}
//                         />

//                         <label>Phone Number *</label>
//                         <input
//                             type="tel"
//                             name="phone"
//                             placeholder="Enter your phone number"
//                             required
//                             value={formData.phone}
//                             onChange={handleChange}
//                         />

//                         <label>How Many Persons *</label>
//                         <input
//                             type="number"
//                             name="persons"
//                             placeholder="Enter number of passengers"
//                             required
//                             value={formData.persons}
//                             onChange={handleChange}
//                         />

//                         <label>Service Type *</label>
//                         <select name="serviceType" required value={formData.serviceType} onChange={handleChange}>
//                             <option value="Day Rent">Day Rent</option>
//                             <option value="Round Trip">Round Trip</option>
//                             <option value="Outstation">Outstation</option>
//                             <option value="Tour Packages">Tour Packages</option>
//                         </select>

//                         {formData.serviceType === "Tour Packages" && (
//                             <>
//                                 <label>Tour Location *</label>
//                                 <select name="tourLocation" required value={formData.tourLocation} onChange={handleChange}>
//                                     <option value="">Select a location</option>
//                                     <option value="Madurai">Madurai</option>
//                                     <option value="Kodaikanal">Kodaikanal</option>
//                                     <option value="Coimbatore">Coimbatore</option>
//                                     <option value="Trichy">Trichy</option>
//                                     <option value="Tanjore">Tanjore</option>
//                                     <option value="Velankanni">Velankanni</option>
//                                     <option value="Rameshwaram">Rameshwaram</option>
//                                     <option value="Kanyakumari">Kanyakumari</option>
//                                     <option value="Trivandrum">Trivandrum</option>
//                                     <option value="Alappuzha">Alappuzha</option>
//                                     <option value="Munnar">Munnar</option>
//                                     <option value="Thekkadi">Thekkadi</option>
//                                 </select>
//                             </>
//                         )}

//                         <button type="submit" className="send-btn" disabled={isLoading}>
//                             {isLoading ? "Booking..." : "Book Ride"}
//                         </button>

//                         {status && <p className="status-message">{status}</p>}
//                     </form>
//                 </div>

//                 <div className="col-md-6">
//                     <div className="contact-infos">
// <h2>
//     இப்பொழுது மதுரை மாநகரில் 24 மணி நேர உள்ளூர் மற்றும் வெளியூர்
//     பயணங்களுக்கு துரித சேவையில் மிக குறைந்த வாடகையில் எங்கள் சேவையினை
//     வழங்கி வருகிறோம் .வாருங்கள்! ஆதரவு தாருங்கள்! வளர்கிறோம்!உங்கள்
//     பாதுகாப்பான வெற்றி பயணங்களில் தோழனாய் எங்களையும் இணைத்து
//     கொள்ளுங்கள்.
// </h2>
//                         <h2>
//                             We are now offering our service at the lowest rates in the express service for 24-hour local and long-distance travel in Madurai.
//                             Join us as a companion on your safe journey of success.
//                         </h2>
//                         <div className="footer-contact">
//                             <p>
//                                 <i className="fas fa-phone"></i>
//                                 <a href="tel:+918072938793"> +91 8072938793</a>
//                             </p>
//                             <p>
//                                 <i className="fab fa-whatsapp"></i>
//                                 <a href="https://wa.me/919486757405"> +91 9486757405</a>
//                             </p>
//                             <p>
//                                 <i className="fas fa-envelope"></i>
//                                 <a href="mailto:gvtravelsmadurai@gmail.com"> gvtravelsmadurai@gmail.com</a>
//                             </p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Contact;


import React, { useState } from "react";
import "./Contact.css";
import "./Footer.css";

const Contact = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        persons: "",
        serviceType: "Day Rent",
        tourLocation: "",
        customTourLocation: "", // New state for custom tour input
    });

    const [status, setStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate phone number format (Only on submit)
        const phonePattern = /^[6789]\d{9}$/; // Indian Mobile Number Format
        if (!phonePattern.test(formData.phone)) {
            setStatus("Please enter a valid 10-digit Indian mobile number.");
            return;
        }

        // Ensure custom tour location is filled if 'custom tour' is selected
        if (formData.tourLocation === "custom tour" && !formData.customTourLocation.trim()) {
            setStatus("Please enter your custom tour location.");
            return;
        }

        setIsLoading(true);
        setStatus("");

        // Prepare data to send
        const submissionData = {
            ...formData,
            tourLocation: formData.tourLocation === "custom tour" ? formData.customTourLocation : formData.tourLocation
        };

        try {
            const response = await fetch("https://smtp-server-zscs.onrender.com/send-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(submissionData),
            });

            const data = await response.json();
            console.log("Server Response:", data);

            if (response.ok) {
                setStatus("Your booking is confirmed. Our team will contact you soon!");
                setFormData({
                    fullName: "",
                    email: "",
                    phone: "",
                    persons: "",
                    serviceType: "Day Rent",
                    tourLocation: "",
                    customTourLocation: "",
                });
            } else {
                setStatus(data.message || "Error sending message. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            setStatus("Network error. Please try again.");
        }

        setIsLoading(false);
        setTimeout(() => setStatus(""), 5000);
    };

    return (
        <div className="container">
            <div className="row d-flex align-items-center">
                <div className="col-md-6">
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <h1 className="contact-title">Book Online</h1>

                        <label>Full Name *</label>
                        <input
                            type="text"
                            name="fullName"
                            placeholder="E.g: Praveen"
                            required
                            value={formData.fullName}
                            onChange={handleChange}
                        />

                        <label>Email Address *</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="mail@example.com"
                            required
                            value={formData.email}
                            onChange={handleChange}
                        />

                        <label>Phone Number *</label>
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Enter your phone number"
                            required
                            value={formData.phone}
                            onChange={handleChange}
                        />

                        <label>How Many Persons *</label>
                        <input
                            type="number"
                            name="persons"
                            placeholder="Enter number of passengers"
                            required
                            value={formData.persons}
                            onChange={handleChange}
                        />

                        <label>Service Type *</label>
                        <select name="serviceType" required value={formData.serviceType} onChange={handleChange}>
                            <option value="Day Rent">Day Rent</option>
                            <option value="Round Trip">Round Trip</option>
                            <option value="Outstation">Outstation</option>
                            <option value="Tour Packages">Tour Packages</option>
                        </select>

                        {formData.serviceType === "Tour Packages" && (
                            <>
                                <label>Tour Location *</label>
                                <select name="tourLocation" required value={formData.tourLocation} onChange={handleChange}>
                                    <option value="">Select a location</option>
                                    <option value="Madurai">Madurai</option>
                                    <option value="Kodaikanal">Kodaikanal</option>
                                    <option value="Coimbatore">Coimbatore</option>
                                    <option value="Trichy">Trichy</option>
                                    <option value="Tanjore">Tanjore</option>
                                    <option value="Velankanni">Velankanni</option>
                                    <option value="Rameshwaram">Rameshwaram</option>
                                    <option value="Kanyakumari">Kanyakumari</option>
                                    <option value="Trivandrum">Trivandrum</option>
                                    <option value="Alappuzha">Alappuzha</option>
                                    <option value="Munnar">Munnar</option>
                                    <option value="Thekkadi">Thekkadi</option>
                                    <option value="custom tour">Custom Trip</option>
                                </select>
                            </>
                        )}

                        {/* Show input field when 'custom tour' is selected */}
                        {formData.tourLocation === "custom tour" && (
                            <>
                                <label>Enter Custom Tour Location *</label>
                                <input
                                    type="text"
                                    name="customTourLocation"
                                    placeholder="Eg: Madurai - Tiruchendur"
                                    required
                                    value={formData.customTourLocation}
                                    onChange={handleChange}
                                />
                            </>
                        )}

                        <button type="submit" className="send-btn" disabled={isLoading}>
                            {isLoading ? "Booking..." : "Book Ride"}
                        </button>

                        {status && <p className="status-message">{status}</p>}
                    </form>
                </div>

                <div className="col-md-6">
                    <div className="contact-infos">
                        <h2>
                            இப்பொழுது மதுரை மாநகரில் 24 மணி நேர உள்ளூர் மற்றும் வெளியூர்
                            பயணங்களுக்கு துரித சேவையில் மிக குறைந்த வாடகையில் எங்கள் சேவையினை
                            வழங்கி வருகிறோம் .வாருங்கள்! ஆதரவு தாருங்கள்! வளர்கிறோம்!உங்கள்
                            பாதுகாப்பான வெற்றி பயணங்களில் தோழனாய் எங்களையும் இணைத்து
                            கொள்ளுங்கள்.
                        </h2>
                        <h2>
                            We are now offering our service at the lowest rates in the express service for 24-hour local and long-distance travel in Madurai.
                            Join us as a companion on your safe journey of success.
                        </h2>
                        <div className="footer-contact">
                            <p>
                                <i className="fas fa-phone"></i>
                                <a href="tel:+918072938793"> +91 8072938793</a>
                            </p>
                            <p>
                                <i className="fab fa-whatsapp"></i>
                                {/* <a href="https://wa.me/919486757405"> +91 9486757405</a> */}
                                <a href="https://wa.me/919486757405" target="_blank" rel="noopener noreferrer">
                                    +91 9486757405
                                </a>
                            </p>
                            <p>
                                <i className="fas fa-envelope"></i>
                                <a href="mailto:gvtravelsmadurai@gmail.com"> gvtravelsmadurai@gmail.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
